/**
 * Classe base para a formatação de dados.
 * @author: Adalto Junior
 * Date: 11/08/2014
 */


Monet.Format = Monet.Format || {};
Monet.Format.Base = function (value) {

    this.value = value;

    this.toGrid = function () {
        return this;
    };

    this.getValue = function () {
        return Monet.I18n.getResourcesByKey(this.value);
    };

};
